module.exports = __webpack_public_path__ + "img/liget-bird-view.2ffa7f2.jpg";